import ReactDOM from 'react-dom';
import App from './app';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

// ReactDOM.render(<App />, document.getElementById('root'));
const root = createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />,
  </BrowserRouter>,
);
